<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid class="pb-10">
            <v-card flat>
                <v-toolbar flat>
                    <v-toolbar-title>{{ $t('animal.animalDetails') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="$router.go(-1)" outlined color="primary"> {{ $t('geneticsAndBreeding.back') }}</v-btn>
                </v-toolbar>
                <v-card-text class="px-6">
                    <v-row class="expansion-header d-flex justify-space-between align-center px-2 black--text">
                        <div>{{ animalIdentification.internationalId }}</div>
                        <div class="font-weight-bold">{{ animalIdentification.AnimalEpd?.breed }}</div>
                        <div>{{ $t('epdD.eighteight') }}</div>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col lg="3" md="3" sm="12" xs="12" class="pa-0">
                            <v-img 
                                    class="pa-2" 
                                    :src="animalImage"
                                    :lazy-src="animalImage"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                        </v-col>
                        <v-col lg="9" md="9" sm="12" xs="12">
                            <div class="d-flex justify-space-between">
                                <div>
                                    <div class="pl-4 font-weight-bold black--text">{{ $t('animal.identification') }}</div>
                                    <v-row no-gutters>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('geneticsAndBreeding.sex') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold text-capitalize">{{ animalIdentification.gender }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('geneticsAndBreeding.animalID') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold text-wrap">{{ animalIdentification.animalNumber }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('geneticsAndBreeding.tattoo') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold">{{ animalIdentification.tattoo }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('name') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold text-capitalize text-wrap">{{ animalIdentification.name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('geneticsAndBreeding.internationalID') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold">{{ animalIdentification.internationalId }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('epdD.Horn_Poll_Scur') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold text-capitalize">{{ animalIdentification.hornStatus }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('color') }}</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold">{{ animalIdentification.colorId || '-' }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{ $t('animal.tagH') }} #</v-list-item-subtitle>
                                                        <v-list-item-title class="font-weight-bold text-wrap">{{ animalIdentification.tagNumber || '-' }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div><v-divider vertical></v-divider></div>
                                <div>
                                    <div class="pl-4 font-weight-bold black--text">{{ $t('epdD.otherResults') }}</div>
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.owner') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold "><a class="text-capitalize" href="">{{ animalIdentification.ownerName || '-' }}</a></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.breeder') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold text-capitalize"> {{ animalIdentification.breeder || '-' }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.sire') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold text-capitalize text-wrap">
                                                                <span v-if="animalIdentification.sireId">{<a @click="$router.push({name: 'AnimalDetails', params: {animal_number: animalIdentification.sireId}})">{{ animalIdentification.sireId || '-' }}</a>} {{ animalIdentification.sireName || '-' }}</span>
                                                                <span v-else>-</span>
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.dam') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold text-capitalize text-wrap">
                                                                <span v-if="animalIdentification.damId">{<a @click="$router.push({name: 'AnimalDetails', params: {animal_number: animalIdentification.damId}})">{{ animalIdentification.damId || '-' }}</a>} {{ animalIdentification.damName || '-' }}</span>
                                                                <span v-else>-</span>
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.conceptionMethod') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold">{{ conceptionMethod.find(c => c.value == animalIdentification.conceptionMethod) && conceptionMethod.find(c => c.value == animalIdentification.conceptionMethod).text || '-' }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-subtitle>{{ $t('animal.dateOfBirth') }}</v-list-item-subtitle>
                                                            <v-list-item-title class="font-weight-bold">{{ animalIdentification.birthDate || '-' }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                        </v-row>
                                    </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-5" flat>
                <v-tabs
                    v-model="tab"
                >

                    <v-tab
                        v-for="item in tabs"
                        :key="item"
                        class="text-capitalize"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </v-card>
            <v-card class="mt-5" flat>
                <v-card-text>
                    <v-tabs-items v-model="tab">
                        <v-tab-item> <EPDs/> </v-tab-item>
                        <v-tab-item> <Pedigree/> </v-tab-item>
                        <v-tab-item><Progeny/> </v-tab-item>
                        <v-tab-item> <Performance/> </v-tab-item>
                        <v-tab-item> <OwnerDetails/> </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>

import EPDs from "./single-epd/EPDs.vue"
import Progeny from "./single-epd/Progeny.vue"
import OwnerDetails from "./single-epd/OwnerDetails.vue"
import Performance from "./single-epd/Performance.vue"
import Pedigree from "./single-epd/Pedigree.vue"
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    components: {
        EPDs,
        Progeny,
        OwnerDetails,
        Performance,
        Pedigree
    },
    mounted() {
        this.startLoading()
        EPDService.getSingleEpdInfo(this.$route.params.geneticid)
        .then(({data}) => {
            // console.log('res',data)
            this.animalImage = data?.img?.url || '/img/no_img.png'
            this.animalIdentification = {...data}
            this.stopLoading()
        })
        .catch(e => {
            console.log('err', e)
            this.stopLoading()
        });
    },
    data() {
        return {
            tab: 0,
            tabs: [
                'EPDs',
                this.$t('epdD.pedigree'),
                this.$t('epdD.progeny'),
                this.$t('epdD.performance'),
                this.$t('epdD.ownerDetail')
            ],
            animalIdentification: {},
            animalImage: '/img/no_img.png',
            conceptionMethod: [
                { text: "Natural Mating", value: "1" },
                { text: "Artificial Insemination", value: "2" },
                { text: "Embryo Transfer", value: "3" },
            ],
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('Edit Genetics'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
        }
    },
    mixins: [loadingMixin]
}
</script>
<style scoped>
.expansion-header {
    border: 1px solid #FFB443 !important; 
    background-color: #FFF7EC !important;
    min-height: 60px;
    border-radius: 5px;
 }

 .label {
     margin-bottom: 20px !important;
 }
</style>